import React from "react";
import styles from "./styles/PageNotFound.module.scss";
import AppleLogoButton from "assets/images/tutorial/apple-logo";
import GoogleLogoButton from "assets/images/tutorial/google-logo";
import FooterQRCode from "components/FooterQRCode";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Link to="/">
          <img
            className={styles.timelessXLogo}
            src={require("assets/images/tutorial/wordmark.png")}
            alt="timeless-logo"
          />
        </Link>
        <div className={styles.downloadAppButtonGroup}>
          <a
            href="https://apps.apple.com/us/app/timeless-x/id6470180600"
            className={styles.downloadButton}
            target="_blank"
            rel="noreferrer"
          >
            <AppleLogoButton className={styles.iconSize} />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=xyz.timelesswallet.aa"
            className={styles.downloadButton}
            target="_blank"
            rel="noreferrer"
          >
            <GoogleLogoButton className={styles.iconSize} />
          </a>
        </div>
      </div>
      <div className={styles.contentContainer}>
        <span className={styles.textNotFound}>404</span>
      </div>
      <FooterQRCode />
    </div>
  );
};

export default PageNotFound;
